import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import TabFooter from "root/components/TabFooter";
import t from "common/i18n";
import { ROUTES } from "../../data/consts";
import { useAssets, useUI } from "../../selectors";
import useCurrentPage from "../../hooks/useCurrentPage";
import { getInternalPath } from "../../utils";
import UploadButton from "./UploadButton";
import SVG_ICONS from "~/assets/icons/icons";

export default ({ togglePanel, uploadAsset }) => {
	const history = useHistory();
	const { selected } = useAssets();
	const { isSummaryPage } = useCurrentPage();
	const { isFiltersPanelOpen, uploadInProgress } = useUI();

	const secondaryButtonClick = useCallback(() => {
		history.push(getInternalPath(ROUTES.SUMMARY));
		if (isFiltersPanelOpen) {
			togglePanel();
		}
	}, [history, isFiltersPanelOpen, togglePanel]);

	return <TabFooter showActionButton={selected && !isSummaryPage}
		actionButtonActive
		actionButtonText={t("actions.next")}
		actionButtonIcon={SVG_ICONS.ARROW_FORWARD}
		uploadButtonHandler={secondaryButtonClick}
		secondaryButton={isSummaryPage && <UploadButton uploadAsset={uploadAsset} inProgress={uploadInProgress}/>}
	></TabFooter>;
};

